import * as React from 'react';
import { SVGProps } from '../../types';

export const IconMultipleChoiceSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {/* Filled squares follow currentColor */}
    <rect x="3.5" y="7.5"  width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="3.5" y="11.5" width="3" height="3" rx="1.5" fill="currentColor" />
    <rect x="3.5" y="3.5"  width="3" height="3" rx="1.5" fill="currentColor" />
    {/* Lines use currentColor as stroke */}
    <line x1="9.25" y1="13.25" x2="14.75" y2="13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="9.25" y1="9.25"  x2="14.75" y2="9.25"  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="9.25" y1="5.25"  x2="14.75" y2="5.25"  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
